<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/enrolment/create-course"><i class="fas fa-plus"></i> {{ "CREATE_COURSE" | translate |
                titlecase }}</button>
        </div>

        <div class="col-12">

            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "COURSES_MANAGEMENT" | translate | titlecase }}</h5>

                <app-loader [show]="showLoader"></app-loader>

                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="courses.length >= 1" class="table-striped table-responsive" id="datatable">
                        <thead>
                            <tr>
                                <th rowspan="2">{{ "SUBJECT_CODE" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "SUBJECT_NAME" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "CLASS_HOURS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "PRACTICAL_HOURS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "TOTAL_HOURS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "CREDIT_HOURS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "MIN_ATTEND_HOURS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "MIN_LAB_HOURS" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "CATEGORY" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "FINAL_EXAM_DURATION_HRS" | translate | titlecase }}</th>
                                <th colspan="3" style="text-align: center;">{{ "EXAM_GRADES" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "MARK_GROUP" | translate | titlecase }}</th>
                                <th rowspan="2">{{ "ACTIVE" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey" rowspan="2">{{ "COURSE_MODIFY" | translate | titlecase
                                    }}</th>
                                <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                            </tr>
                            <tr>
                                <th>{{ "FINAL" | translate | titlecase }}</th>
                                <th>{{ "ONGOING" | translate | titlecase }}</th>
                                <th>{{ "TOTAL" | translate | titlecase }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of courses">
                                <td>{{res?.subjectCode}}</td>
                                <td>{{(globals.lang == 'ar')? res.subjectNameAr : res.subjectNameEn}}</td>
                                <td>{{res?.classHours}}</td>
                                <td>{{res?.practicalHours}}</td>
                                <td>{{res?.totalHours}}</td>
                                <td>{{res?.creditHours}}</td>
                                <td>{{res?.minClassHours}}</td>
                                <td>{{res?.minPracticalHours}}</td>
                                <td>{{(globals.lang == 'ar')? res?.courseCategory?.scatNameAr : res?.courseCategory?.scatNameEn}}</td>
                                <td>{{res?.finalDurationHrs}}</td>
                                <td>{{res?.examGradeFinal}}</td>
                                <td>{{res?.examGradeOngoing}}</td>
                                <td>{{res?.examGradeTotal}}</td>
                                <td>{{(globals.lang == 'ar')? res?.markGroup?.mgroupNameAr : res?.markGroup?.mgroupNameEn}}</td>
                                <td>{{(res?.active == 'YES')? ('YES' | translate | titlecase) : ('NO' | translate |
                                    titlecase) }}</td>
                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning" routerLink="/enrolment/update-course"
                                        [queryParams]="{courseId: res?.id}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                                <!-- <td class="text-bold text-warning" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">
                                    <button class="btn btn-sm btn-link text-warning" (click)="editCourse(res?.id)"><i
                                            class="fas fa-edit"></i>
                                            {{ "MODIFY" | translate | titlecase }}</button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>